export const generateValidUrl = () => {
  const url = window.location.href;
  if (url.includes("localhost")) {
    return "http://localhost:3000/finishSignIn";
  } else if (process.env.REACT_APP_ENV === "development") {
    return "https://pa-dashboard-demo-internal.web.app/finishSignIn";
  } else {
    return "https://demo-onco.risalabs.ai/finishSignIn";
  }
};

// #fixed issue with the url not being valid
